





































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation, namespace } from 'vuex-class';
import { TransferService } from './services/TransferService';

import StepForm1 from './components/StepForm1.vue';
import StepForm2 from './components/StepForm2.vue';
import StepForm3 from './components/StepForm3.vue';

@Component({
    components: {
      StepForm1,
      StepForm2,
      StepForm3,
    },
})
export default class StepForm extends Vue {

  public item: TransferService = new TransferService();

  constructor() {
      super();
  }

}
